import _ from "lodash";

export const PaymentModePolicy = () => {
    const ITEM_PO = "PO";
    const ITEM_CASH = "CASH";
    const ITEM_BANK_EDI = "BANK EDI";
    const ITEM_CREDIT_CARD = "POS-CREDIT_CARD";
    const ITEM_LPA = "LPA";
    // const ITEM_SMART_CARD = "POS-SMART_CARD";
    const ITEM_ONLINE_PAYMENT = "ONLINE_PAYMENT";//fix NBIS-4580

    const getPaymentModeDroOptsForOICT = (actionMode: string) => {
        let ret: string[] = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI, ITEM_LPA];
        if (actionMode === 'Deposit' || actionMode === 'Edit') {
            ret = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI, ITEM_CREDIT_CARD];
        } else if (actionMode === 'Opening') {
            ret = [ITEM_PO, ITEM_CASH, ITEM_CREDIT_CARD];
        } else if (actionMode === 'Closure') {
            ret = [ITEM_PO];
        }
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];

    }

    const getPaymentModeDroOptsForSAPT = (actionMode: string) => {
        let ret: string[] = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI, ITEM_LPA];
        if (actionMode === 'Deposit' || actionMode === 'Edit') {
            ret = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI];
        } else if (actionMode === 'Opening') {
            ret = [ITEM_PO, ITEM_CASH];
        } else if (actionMode === 'Closure') {
            ret = [ITEM_PO];
        }
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];

    }
    const getCollectionPaymentModeDroOptsForSAPT = () => {
        let ret: string[] = [ITEM_PO, ITEM_CASH];
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];

    }

    const getModeItemDroOptsForOICT = () => {
        let ret: string[] = [ITEM_PO, ITEM_CASH, ITEM_CREDIT_CARD, ITEM_ONLINE_PAYMENT];
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];

    }
    const getPaymentModeDroOptsFor = (actionMode: string, operatingUnit: string) => {
        let ret: string[] = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI, ITEM_LPA];
        if (operatingUnit === 'SAPT' || operatingUnit === 'KICT') {
            if (actionMode === 'Deposit' || actionMode === 'Edit') {
                ret = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI];
            } else if (actionMode === 'Opening') {
                ret = [ITEM_PO, ITEM_CASH];
            } else if (actionMode === 'Closure') {
                ret = [ITEM_PO];
            }
        }
        if (operatingUnit === 'AQCT' || operatingUnit === 'RSCT' || operatingUnit === 'OICT' || operatingUnit === 'HPJZ') {
            if (actionMode === 'Deposit' || actionMode === 'Edit') {
                ret = [ITEM_PO, ITEM_CASH, ITEM_BANK_EDI, ITEM_CREDIT_CARD];
            } else if (actionMode === 'Opening') {
                ret = [ITEM_PO, ITEM_CASH, ITEM_CREDIT_CARD];
            } else if (actionMode === 'Closure') {
                ret = [ITEM_PO];
            }
        }
        return [
            ...(_.map(
                _.toPairs(ret), ([key, value]) => (
                    { dropdownLabel: value, tagLabel: value, value: value }
                )
            ) ?? [])];
    }
    return {
        getCollectionPaymentModeDroOptsForSAPT,
        getPaymentModeDroOptsForSAPT,
        getPaymentModeDroOptsForOICT,
        getPaymentModeDroOptsFor,
        getModeItemDroOptsForOICT,
    }
}
